import { useCallback, useEffect, useMemo, useState } from 'react';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';

import { cmApi } from '@src/api';
import { dataControlStore } from '@stores/dataControlStore';
import type { TableComponentRequestDto } from '@src/api';

interface IData {
  report_package_code_cm?: string;
  ctrl_vers?: string;
  ctrl_vers_ext?: string;
  ctrl_vers_desc?: string;
  status?: string;
  status_text?: string;
  ctrl_name?: string;
  user_kp?: string;
  date_kp?: string;
  period_kp?: string;
  exec_num?: string;
}

export const useUpdateTitle = (): { titleData: IData; updateTitle: () => void } => {
  const [titleData, setTitleData] = useState<IData>({});

  const { lastPagesParam, filters } = dataControlStore;
  const { runNumber } = filters.controlLevel || {};

  const updateTitle = useCallback(() => {
    if (!runNumber) return;

    const hardFilter = [...(lastPagesParam.filters?.[0] ?? [])];

    hardFilter.push({
      name: 'exec_num',
      type: FILTER.EQ,
      values: [runNumber],
      filterIsInverted: false,
    });

    const tableInfo = {
      aggregate: {},
      fields: [
        'report_package_code_cm',
        'ctrl_vers',
        'ctrl_vers_ext',
        'ctrl_vers_desc',
        'status_out',
        'ctrl_name',
        'user_kp',
        'date_kp',
        'period_kp',
        'exec_num',
      ],
      hardFilter: [hardFilter],
      filter: [],
      groupBy: [],
      limit: 1,
      offset: 0,
      openGroup: [],
      orderBy: [],
      resource: 'v_ctrl_pckg',
    };

    cmApi.tableComponentV2.getTableJson(tableInfo as unknown as TableComponentRequestDto).then((response) => {
      const result = response?.data as unknown as { data: IData };

      if (result && result.data) {
        setTitleData(result.data[0]);
      }
    });
  }, [lastPagesParam.filters, runNumber]);

  useEffect(() => {
    updateTitle();
  }, [updateTitle]);

  return useMemo(() => ({ titleData, updateTitle }), [titleData, updateTitle]);
};
